const messages = {
  title: "Über Bridgestone <span class='text-danger'>Plus</span>",
  description:
    "IHR <span class='text-danger'>PLUS</span> MIT BRIDGESTONE - dies ist unser Leitmotiv des gesamten BRIDGESTONE <span class='text-danger'>PLUS</span> Programms für unsere Handelspartner. Entdecken Sie die zahlreichen exklusiven Vorteile.",
};

export default {
  messages,
};
